import { Injectable } from '@angular/core';
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MxAlertService } from 'mx-commons';
import { SaveService } from './shared/services/save.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

	constructor(
		private readonly alert: MxAlertService,
		private readonly saveService: SaveService
	) {

	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token: string = localStorage.getItem('token');

		if (token && !request.headers.has('Authorization')) {
			request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
		}

		if (!request.headers.has('Content-Type')) {
			request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
			request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
		}

		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				this.saveService.saving = false;
				if (error.status === 500) {
					this.alert.error(`Ops, ${error.error.message}`);
				}
				console.log('ERRO', error.status, error);
				return throwError(error);
			}));

	}

}
